import React from 'react';
import { Text } from '@good/ui/core';

interface CardTimeProps {
  startTime: string;
  endTime: string;
}

export const CardTime = ({ startTime, endTime }: CardTimeProps) => {
  return (
    <Text size='sm' lh={1}>
      <b>{startTime}</b> - {endTime}
    </Text>
  );
};
